var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveServiceRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41685 5.41671L2.50019 2.50004M1.91685 3.37504L3.37519 1.91671L1.62519 1.04171L1.04185 1.62504L1.91685 3.37504ZM10.6523 4.23546C10.9323 3.95564 11.125 3.60044 11.2068 3.21309C11.2886 2.82574 11.2561 2.42296 11.1131 2.05379L10.2836 2.88329H9.11694V1.71662L9.94644 0.887122C9.57724 0.743821 9.17433 0.710991 8.7868 0.792632C8.39927 0.874273 8.04385 1.06686 7.76385 1.34693C7.48384 1.627 7.29133 1.98246 7.20978 2.37001C7.12822 2.75755 7.16114 3.16045 7.30452 3.52962L3.53035 7.30437C3.16119 7.16099 2.75829 7.12807 2.37074 7.20963C1.98319 7.29118 1.62773 7.48369 1.34766 7.7637C1.06759 8.04371 0.875005 8.39912 0.793365 8.78665C0.711724 9.17418 0.744554 9.57709 0.887855 9.94629L1.71677 9.11679H2.88344V10.2835L2.05394 11.113C2.42305 11.2563 2.82586 11.2891 3.21332 11.2076C3.60078 11.126 3.95617 10.9336 4.23621 10.6537C4.51624 10.3738 4.70885 10.0185 4.79056 9.63104C4.87228 9.24362 4.83957 8.84079 4.69644 8.47162L8.47177 4.69629C8.84079 4.83902 9.24334 4.87145 9.63045 4.78964C10.0176 4.70782 10.3726 4.51529 10.6523 4.23546Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88184 7.45834L9.15084 10.7273C9.22398 10.8006 9.31086 10.8588 9.4065 10.8984C9.50214 10.9381 9.60467 10.9585 9.70821 10.9585C9.81175 10.9585 9.91428 10.9381 10.0099 10.8984C10.1056 10.8588 10.1924 10.8006 10.2656 10.7273L10.7276 10.2653C10.8009 10.1922 10.859 10.1053 10.8987 10.0097C10.9383 9.91403 10.9588 9.81151 10.9588 9.70797C10.9588 9.60443 10.9383 9.5019 10.8987 9.40626C10.859 9.31062 10.8009 9.22374 10.7276 9.15059L7.45859 5.88159",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveServiceRequest);
export default __webpack_public_path__ + "static/media/ActiveServiceRequest.8664b0b121bc98d7ae2292185c439162.svg";
export { ForwardRef as ReactComponent };